module.exports = __webpack_public_path__ + "static/media/icon-user-settings.364c28c1.svg";